<template>

    <div class="container programaciones_wrapper">
      <div class="tabla">

          <b-button v-b-toggle.collapseEntregaLibro variant="link"><h3>Activación de cursos</h3></b-button>

          <b-collapse id="collapseEntregaLibro">
            
            <div class="text-center mb-3 mt-3 row">
              <div class="col-md-4"><small><strong>Creado por</strong></small></div>
              <div class="col-md-4"><small><strong>Curso Anterior</strong></small></div>
              <div class="col-md-4"><small><strong>Curso Siguiente</strong></small></div>
            </div>
            <DetalleEntregaLibroItem v-for="(item, index_2) in entrega_libros" :key="'EL'+index_2"
          :item="item" :estudiante="estudiante"/>
          
        </b-collapse>
      </div>
    </div>
  </template>
  
  <script>
    import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
    import DetalleEntregaLibroItem from '@/components/Estudiantes/DetalleEntregaLibroItem';
    export default {
      name: 'DetalleEntregaLibro',
      components: {
        DetalleEntregaLibroItem
      },
      data () {
        return {
          entrega_libros:null
        }
      },
      props: {
        estudiante: Object
      },
      mounted () {
        if(this.estudiante.entrega_libros === undefined ){
          console.log('DetalleEntregaLibroItem undefined')
          this.fetchEntregaLibros(this.estudiante.id).then((result) => {
            this.entrega_libros = result.entrega_libros;
          })
        } else {
          this.entrega_libros = this.estudiante.entrega_libros;
        }
        
      },
      methods:{
        ...mapActions({
          fetchEntregaLibros: 'estudiantes/fetchEntregaLibros',
          fetchDetalle: 'estudiantes/fetchDetalle',
          cancelar: 'programacion/cancelar',
        }),
        ...mapMutations({
          
        })
  
      },
      computed: {
        ...mapState({
          
        }),
        ...mapGetters({
  
        }),
        
      }
    }
  </script>
  
  <style scope>
  
      .programaciones_wrapper .tabla{
        
      }
  </style>